export default "__VITE_ASSET__BxxilXxu__"